import ClearOutlinedIcon from "@mui/icons-material/ClearOutlined";
import SearchIcon from "@mui/icons-material/Search";
import { FormControlLabel } from "@mui/material";
import TextField from "@mui/material/TextField";
import { DataGrid, GridColumns } from "@mui/x-data-grid";
import { EditButton, List, useDataGrid } from "@refinedev/mui";
import { RemoveButton } from "components/buttons/remove";
import React, { useState } from "react";

export const ProductsList = () => {
  const { dataGridProps, setFilters, setCurrent, setPageSize } = useDataGrid({
    sorters: {
      initial: [
        {
          field: "updatedAt",
          order: "desc"
        }
      ]
    },
    filters: {
      permanent: [
        {
          field: "activeStatus",
          operator: "eq",
          value: 0,
        },
      ],
    },
    pagination: {
      pageSize: 10
    }
  });
  
  const columns = React.useMemo<GridColumns<any>>(
    () => [
      {
        field: "id",
        headerName: "Id",
        type: "number",
        minWidth: 100,
        hideable: false,
      },
      {
        field: "crmId",
        headerName: "CRM Product ID",
        minWidth: 150,
        hideable: false,
      },
      {
        field: "description",
        headerName: "Description",
        minWidth: 300,
        flex: 1,
        hideable: false,
      },
      {
        field: "createdAt",
        headerName: "CreatedAt",
        minWidth: 200,
        hideable: false,
        renderCell: function render({ row }) {
          if (row.createdAt) {
            return new Date(row.createdAt).toLocaleString();
          } else {
            return "";
          }
        },
      },
      {
        field: "updatedAt",
        headerName: "UpdatedAt",
        minWidth: 200,
        hideable: false,
        renderCell: function render({ row }) {
          if (row.updatedAt) {
            return new Date(row.updatedAt).toLocaleString();
          } else {
            return "";
          }
        },
      },
      {
        field: "actions",
        headerName: "Actions",
        hideable: false,
        sortable: false,
        renderCell: function render({ row }) {
          return (
            <>
              <EditButton hideText recordItemId={row.id} />
              <RemoveButton hideText recordItemId={row.id} />
            </>
          );
        },
        align: "center",
        headerAlign: "center",
        minWidth: 100,
      },
    ],
    []
  );

  // search parts
  const [crmId, setCrmId] = useState("");
  const [description, setDescription] = useState("");
  const [id, setId] = useState("");
  const handleFilter = () => {
    setCurrent(1);
    setPageSize(10);
    let searchArr: { field: string; value: string; operator: string }[] = [];
    if (crmId) {
      searchArr.push({
        field: "crmId[$ilike]",
        value: `%${crmId}%`,
        operator: "eq",
      });
    }
    if (description) {
      searchArr.push({
        field: "description[$ilike]",
        value: `%${description}%`,
        operator: "eq",
      });
    }
    if (id) {
      searchArr.push({
        field: "id",
        value: `${id}`,
        operator: "eq",
      });
    }
    setFilters(searchArr as any);
  };

  const clearFun = () => {
    setCrmId("");
    setDescription("");
    setId("");
  };
  return (
    <List>
      <FormControlLabel
        label=""
        style={{ width: "100%" }}
        control={
          <div style={{ width: "100%" }}>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "flex-end",
                width: "100%",
                marginLeft: "19px",
                paddingRight: "15px",
                marginBottom: "12px",
              }}
            >
              <TextField
                id="standard-basic"
                label="Id"
                variant="standard"
                value={id}
                onChange={(e) => setId(e.target.value)}
                style={{ width: "28%" }}
              />
              <TextField
                id="standard-basic"
                label="CrmProduct"
                variant="standard"
                value={crmId}
                onChange={(e) => setCrmId(e.target.value)}
                style={{ width: "28%" }}
              />
              <TextField
                id="standard-basic"
                label="Description"
                variant="standard"
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                style={{ width: "28%" }}
              />
              <div style={{ width: "8%" }}>
                <ClearOutlinedIcon onClick={clearFun} />
                <SearchIcon onClick={handleFilter} />
              </div>
            </div>
          </div>
        }
      />
      <DataGrid {...dataGridProps} columns={columns} autoHeight paginationMode="server" rowsPerPageOptions={[10,20,50]} disableColumnFilter/>
    </List>
  );
};
